/* src/app/shared/components/channel-select-with-reg-list/channel-select-with-reg-list.component.scss */
.tv-ns-primary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  gap: 5px;
  font: 700 13px FranceTV Brown;
  background-color: #F03C64;
  border: 1px solid #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-light-bg:hover {
  background-color: #CC3456;
  border: 1px solid #CC3456;
}
.tv-ns-primary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-primary-large-button-on-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  gap: 5px;
  font: 700 13px FranceTV Brown;
  border: 1px solid #F03C64;
  background-color: #F03C64;
  color: #FFF;
}
.tv-ns-primary-large-button-on-dark-bg:hover {
  border: 1px solid #F03C64;
  background-color: transparent;
}
.tv-ns-primary-large-button-on-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-secondary-large-button-on-light-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  gap: 5px;
  font: 700 13px FranceTV Brown;
  background-color: #FFF;
  color: #244666;
  border: 1px solid #244666;
}
.tv-ns-secondary-large-button-on-light-bg:hover {
  background-color: #244666;
  border: 1px solid #244666;
  color: #FFF;
}
.tv-ns-secondary-large-button-on-light-bg:hover svg path {
  fill: #FFF !important;
}
.tv-ns-secondary-large-button-on-light-bg:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-secondary-large-button-dark-bg {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  gap: 5px;
  font: 700 13px FranceTV Brown;
  background-color: transparent;
  color: #DFEBF7;
  border: 1px solid #DFEBF7;
}
.tv-ns-secondary-large-button-dark-bg:hover {
  border: 1px solid #DFEBF7;
  background-color: #DFEBF7;
  color: #244666;
}
.tv-ns-secondary-large-button-dark-bg:disabled {
  border: 1px solid #244666;
  background-color: rgba(223, 235, 247, 0.1);
  color: #6B90B3;
}
.tv-ns-validation-large-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 8px 16px;
  gap: 5px;
  font: 700 13px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-large-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-large-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-validation-small-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #00D78C;
  border: 1px solid #00D78C;
  color: #FFF;
}
.tv-ns-validation-small-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-validation-small-button:hover {
  background-color: #26C18B;
  border: 1px solid #26C18B;
}
.tv-ns-validation-small-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.tv-ns-small-blue-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  padding: 2px 8px;
  font: 400 10px FranceTV Brown;
  background-color: #0083FF;
  border: 1px solid #0083FF;
  color: #FFF;
}
.tv-ns-small-blue-button mat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-left: 3px;
  padding-top: 1px;
  font-size: 14px;
  width: 14px;
  height: 14px;
}
.tv-ns-small-blue-button:hover {
  background-color: #FFF;
  border: 1px solid #0083FF;
  color: #0083FF;
}
.tv-ns-small-blue-button:disabled {
  background-color: #DFEBF7;
  border: 1px solid #DFEBF7;
  color: #6B90B3;
}
.main-container {
  position: relative;
  display: inline-block;
}
.buttons-container {
  display: flex;
  align-items: center;
  justify-content: center;
}
.channel-select-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  color: #6B90B3;
  border-radius: 100px;
  min-width: 250px;
  padding: 4px 10px 4px 13px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.channel-select-button mat-icon {
  color: #001A33;
}
.channel-select-button:hover {
  background-color: #DFEBF7;
}
.active-channel-select-button {
  background-color: #DFEBF7;
}
.inactive-channel-select-button {
  background-color: #FFF;
}
.dropdown {
  position: absolute;
  background-color: #FFF;
  z-index: 900;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  margin-top: 5px;
  padding: 15px;
  width: 280px;
}
.invisible-dropdown {
  display: none;
}
.visible-dropdown {
  display: block;
}
.inputs-container {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.channel-group-select-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 5px 5px 10px;
  width: 100%;
  border: 1px solid #DFEBF7;
  color: #001A33;
}
.channel-group-select-button:hover {
  border: 1px solid rgba(107, 144, 179, 0.6);
}
.channel-group-select-button:active,
.channel-group-select-button:focus {
  border: 1px solid #0083FF;
  box-shadow: 0 1px 3px 0 rgba(0, 131, 255, 0.3);
}
.channel-group-select-dropdown {
  position: absolute;
  background-color: #FFF;
  z-index: 900;
  border: 1px solid #DFEBF7;
  border-radius: 5px;
  margin-top: 5px;
}
.channel-group-select-dropdown > div:first-child {
  background-color: #DFEBF7;
}
.channel-group-select-option {
  width: 250px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding: 10px 15px;
  cursor: pointer;
  border-bottom: 1px solid #DFEBF7;
}
.channel-group-select-option:hover,
.channel-group-select-option:active,
.channel-group-select-option:focus {
  background-color: #DFEBF7;
}
.channel-select-input {
  margin: 10px 0;
}
.channel-list-container-wrapper {
  border-top: 1px solid #DFEBF7;
  overflow-y: hidden;
}
.channel-list-container {
  overflow-y: auto;
  width: 250px;
  height: 250px;
}
.channel-item-container {
  display: flex;
  border-radius: 5px;
  padding: 10px 0;
}
.channel-item-container:hover {
  background-color: rgba(107, 144, 179, 0.05);
}
.channel-title-image-container {
  display: flex;
  cursor: pointer;
  align-items: center;
  width: 100%;
}
.channel-logo {
  margin-right: 8px;
  margin-left: 5px;
  width: 15px;
  height: auto;
}
.channel-title {
  font: 400 12px FranceTV Brown;
  width: 100%;
}
.margin-left-10 {
  margin-left: 10px;
}
.horizontal-separator {
  height: 1px;
  background-color: #DFEBF7;
  margin-bottom: 5px;
  margin-top: 5px;
}
.reg-channel-list-dropdown {
  position: absolute;
  background-color: #FFF;
  z-index: 900;
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  border-radius: 16px;
  margin-top: 5px;
  padding: 20px;
  width: 300px;
  height: 340px;
}
.reg-channel-container {
  overflow-y: auto;
  height: 245px;
}
.popup-spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}
.channel-button {
  background-color: transparent;
  border: none;
  margin: 0;
  padding: 0;
  text-align: center;
  font: inherit;
  appearance: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 100px;
  margin: 0 5px;
}
.channel-button mat-icon {
  width: 20px;
  height: 20px;
  font-size: 20px;
}
.grey {
  color: #DFEBF7;
}
.yellow {
  color: #FFC946;
}
/*# sourceMappingURL=channel-select-with-reg-list.component.css.map */
